export function dispatchCustomEvent<DetailType>(type: string, detail?: DetailType) {
  const event = new CustomEvent(type, {
    detail,
  })

  window.document?.dispatchEvent(event)
}

window.dispatchCustomEvent = dispatchCustomEvent

export function listenToCustomEvent<DetailType>(type: string, onEvent: (detail: DetailType) => void) {
  const handleEvent = (event: CustomEvent) => {
    onEvent(event.detail)
  }
  window.document.addEventListener(type, handleEvent)

  const removeEvent = () => window.document.removeEventListener(type, handleEvent)

  return removeEvent
}
